import { DateTime } from 'luxon';
import React from 'react';
import { useCookies } from 'react-cookie';
import Lottie from 'react-lottie-player';

import Botao from 'Component/Botao';
import { useAppSelector } from 'Store';

import * as animacao from './parabens.json';

const MeuAniversario = (): React.ReactElement => {
  const [{ aniversario }, setCookie] = useCookies(['aniversario']);
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const fechar = (): void => {
    setCookie('aniversario', 1, {
      expires: DateTime.now().plus({ days: 1 }).toJSDate(),
    });
  };

  return (
    <React.Fragment>
      {!aniversario &&
        usuario?.nascimento.data().toFormat('dd-MM') ==
          DateTime.now().toFormat('dd-MM') && (
          <React.Fragment>
            <div className="modal fade show d-block">
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content bg-transparent border-0 text-center">
                  <Lottie
                    loop={false}
                    play
                    animationData={animacao}
                    style={{ width: '100%' }}
                    renderer={'canvas' as 'svg'}
                  />
                  <p className="display-4 fw-light text-white">
                    Parabéns pelo seu aniversário!
                  </p>
                  <p className="fs-5 fw-light text-white">
                    Queremos de desejar muitas felicidades, saúde e paz para
                    esse mais um ano de vida!
                  </p>
                  <div>
                    <Botao lg tema="light" onClick={fechar}>
                      Fechar
                    </Botao>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal-backdrop"
              style={{ background: 'rgba(0,0,0, 0.8)' }}
            />
          </React.Fragment>
        )}
    </React.Fragment>
  );
};

export default MeuAniversario;
